/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type PlaceholderCostType = typeof PlaceholderCostType[keyof typeof PlaceholderCostType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceholderCostType = {
  Calculation: 'Calculation',
  Onsite: 'Onsite',
  None: 'None',
} as const;
